import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { Amplify } from 'aws-amplify';
// import outputs from './amplify_outputs.json';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import DebugToggle from './components/DebugToggle';
import DevAutoLogin from './components/DevAutoLogin';
import PrivacyConsent from './components/PrivacyConsent';
import ContactButton from './components/ContactButton';
import Home from './pages/Home';
import KIImpulse from './pages/KIImpulse';
import KIKurse from './pages/KIKurse';
import KIWerkstatt from './pages/KIWerkstatt';
import KIWerkstattDeeplearning from './pages/KIWerkstattDeeplearning';
import KIWerkstattVerwaltung from './pages/KIWerkstattVerwaltung';
import StyleTest from './pages/StyleTest';
import Styleguide from './pages/Styleguide';
import Hansalinie from './pages/Hansalinie';
import Kontakt from './pages/Kontakt';

import Impressum from './pages/Impressum';
import Datenschutz from './pages/Datenschutz';
import Login from './pages/Login';
import TutorDashboard from './pages/TutorDashboard';
import StudentPortal from './pages/StudentPortal';
import VideoTest from './pages/VideoTest';
import PartnerDownloads from './pages/PartnerDownloads';
import NotFound from './pages/NotFound';

// Admin Components
import AdminLoginCustom from './pages/AdminLoginCustom';
import AdminDashboard from './pages/AdminDashboard';

// Course Detail Page
import CourseDetailPage from './pages/CourseDetailPage';
// Tutor Detail Page
import TutorDetailPage from './pages/TutorDetailPage';
// QR Redirect Page
import QRRedirect from './pages/QRRedirect';

import './App.css';
import './pages/Pages.css';
import './pages/CourseDetailPage.css';
import './pages/TutorDetailPage.css';
import './pages/PartnerDownloads.css';
import './pages/NotFound.css';
import './utils/debug.css';

// Amplify is already configured in index.tsx

function AppContent() {
  return (
    <DevAutoLogin>
      <div className="App">
        <ScrollToTop />
        <DebugToggle />
      
      <Routes>
        {/* Admin Dashboard - Without Header/Footer (keep separate for admin interface) */}
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        
        {/* QR Code Redirect - Without Header/Footer for clean branded experience */}
        <Route path="/qr/:campaignId" element={<QRRedirect />} />

        {/* All Routes - With Header/Footer */}
        <Route path="/*" element={
          <>
            <Header />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/ki-impulse" element={<KIImpulse />} />
                <Route path="/ki-kurse" element={<KIKurse />} />
                <Route path="/ki-werkstatt" element={<KIWerkstatt />} />
                <Route path="/ki-werkstatt/produktion" element={<KIWerkstattDeeplearning />} />
                <Route path="/ki-werkstatt/verwaltung" element={<KIWerkstattVerwaltung />} />
                <Route path="/styletest" element={<StyleTest />} />
                <Route path="/hansalinie" element={<Hansalinie />} />
                <Route path="/courses/:courseSlug" element={<CourseDetailPage />} />
                <Route path="/tutors/:tutorSlug" element={<TutorDetailPage />} />
                <Route path="/kontakt" element={<Kontakt />} />

                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />
                <Route path="/admin/login" element={<AdminLoginCustom />} />
                <Route path="/video-test" element={<VideoTest />} />
                <Route path="/tutor-dashboard" element={<TutorDashboard />} />
                <Route path="/student-portal" element={<StudentPortal />} />
                <Route path="/partnerdownloads" element={<PartnerDownloads />} />
                {/* Internal Styleguide - Hidden, password-gated.
                    Not linked from nav/footer; only reachable by direct URL. */}
                <Route path="/styleguide" element={<Styleguide />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
            <PrivacyConsent />
            <ContactButton />
          </>
        } />
      </Routes>
      </div>
    </DevAutoLogin>
  );
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AppContent />
    </Router>
  );
}

export default App;